import { default as React, useContext, useEffect, useState } from "react";
import { FlowStoreContext } from "../../store/FlowStore";
import { WidgetStoreContext } from "../../store/WidgetStore";
import { firebase } from "../firebase/firebase";
import DeleteRemixWidgetModal from "./DeleteRemixWidgetModal.js";
import LockRemixWidgetModal from "./LockRemixWidgetModal.js";
import UnlockRemixWidgetModal from "./UnlockRemixWidgetModal.js";
import { FaLink, FaTextWidth, FaMicrophone, FaImage, FaSearch, FaFilePdf } from 'react-icons/fa';


const LinkComponent = () => {
  return(<div></div>)
}

const TextComponent = () => {
    return(<div></div>)

}

const AudioComponent = () => {
    return(<div></div>)

}

const GenerateImageComponent = () => {
    return(<div></div>)

}

const ImageComponent = () => {
    return(<div></div>)

}

const WebSearchComponent = () => {
    return(<div></div>)

}

const PdfInfoComponent = () => {
    return(<div></div>)

}

const GenerateImage = () => <div style={{display:'flex', alignItems:'center'}}><div style={{height:77, width:'calc(100% - 80px)', margin:'auto', backgroundColor:'rgb(55, 55, 55)', borderRadius:7}}>
  <textarea style={{height:'100%', width:'100%', borderRadius:7, resize:'none', outline:'none', padding:10, fontFamily:'quicksand', backgroundColor:'#373737', color:'white', border:'none'}} placeholder="Describe the image you want to be generated"></textarea>
  </div>   <button
// onClick={handleSendMessage}
style={{
    backgroundColor: "#4FD975",
    width: 50,
    height: 40,
    border: "none",
    borderRadius: 10,
    marginRight:10
}}
>
<img src="../images/chat-arrow.svg" alt="Send" />
</button></div>;
const UseImage = () => <div style={{height:77, width:'calc(100% - 20px)', margin:'auto', backgroundColor:'rgb(55, 55, 55)', borderRadius:7}}></div>
const AudioRecording = () => <div style={{height:77, width:'calc(100% - 20px)', margin:'auto', backgroundColor:'rgb(55, 55, 55)', borderRadius:7}}><button onClick={()=>{
  let iframe = document.getElementById('undefined_output_frame');
  iframe.contentWindow.flowroom.startRecording();
}}>Start</button>
<button onClick={async () => {
  let iframe = document.getElementById('undefined_output_frame');
  let result = await iframe.contentWindow.flowroom.stopRecording();
  
  // Extract base64 string by removing the prefix `data:audio/mp3;base64,`
  let base64String = result.split(',')[1];
  
  // Decode the base64 string to binary data
  let binaryString = window.atob(base64String);
  let len = binaryString.length;
  let bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  
  // Create a Blob from the binary data
  let blob = new Blob([bytes], {type: 'audio/mp3'});
  
  // Create a file from the Blob
  let file = new File([blob], "recording.mp3", {type: 'audio/mp3'});

  // Upload the file and get the URL
  let uploadResponse = await iframe.contentWindow.flowroom.uploadImageFile(file);
  console.log(uploadResponse);  // Log the response to understand its structure

  // Extract URL if it exists
  let uploadedFileUrl = uploadResponse && uploadResponse.url;
  if (uploadedFileUrl) {
    // Append '.mp3' to the URL if it doesn't already end with '.mp3'
    if (!uploadedFileUrl.endsWith('.mp3')) {
      uploadedFileUrl += '.mp3';
    }
  } else {
    console.error("URL not provided in the response.");
    return; // Exit if no URL is found
  }

  // Append an audio player to the 'audio' div that plays the uploaded recording
  let audioContainer = document.getElementById('audio');
  audioContainer.innerHTML = ''; // Clear previous audio elements if any
  let audioElement = document.createElement('audio');
  audioElement.controls = true;
  audioElement.src = uploadedFileUrl; // Set the source to the uploaded file URL
  audioElement.type = 'audio/mp3'; // Explicitly set the MIME type
  audioContainer.appendChild(audioElement);

}}>Stop</button>
<div id="audio"></div>




</div>;

const PDFViewer = () => <div style={{height:77, width:'calc(100% - 20px)', margin:'auto', backgroundColor:'rgb(55, 55, 55)', borderRadius:7}}></div>;

function TabMenu() {
  const [activeTab, setActiveTab] = useState('defaultTab');
  const [inputMessage, setInputMessage] = useState('');

  const handleSendMessage = () => {
      let iframe = document.getElementById('undefined_output_frame');
      if (iframe && iframe.contentWindow) {
          setInputMessage("");
      }
  };

  const tabs = {
      defaultTab: { name: "Text", component: (
        <div style={{ display: "flex", margin: "auto", width: "calc(100% - 20px)", left: 10 }}>
          <input
              type="text"
              value={inputMessage}
              onChange={(e) => setInputMessage(e.target.value)}
              onKeyPress={(e) => {
                  if (e.key === 'Enter') handleSendMessage();
              }}
              placeholder="Type your message..."
              style={{
                  backgroundColor: "#373737",
                  height: 40,
                  paddingLeft: 10,
                  border: "none",
                  borderTopLeftRadius: 10,
                  borderBottomLeftRadius: 10,
                  outline: "none",
                  width: "100%",
                  fontSize: 14,
                  color: "white",
                  fontFamily: "quicksand",
              }}
          />
          <button
              onClick={handleSendMessage}
              style={{
                  backgroundColor: "#4FD975",
                  width: 50,
                  height: 40,
                  border: "none",
                  borderRadius: 10,
              }}
          >
              <img src="../images/chat-arrow.svg" alt="Send" />
          </button>
        </div>
      )},
      secondTab: { name: "Generate Image", description:'This is used to respond with a generated image.', component: <GenerateImage /> },
      thirdTab: { name: "Use Image",description:'This is used to respond with a generated image.', component: <UseImage /> },
      fourthTab: { name: "Audio Recording", description:'This is used to respond with a generated image.', component: <AudioRecording /> },
      fifthTab: { name: "PDF", description:'This is used to respond with a generated image.', component: <PDFViewer /> }
  };

  return (
      <div>
          <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', width: '100%', maxWidth: 400, bottom: 130 }}>
              {Object.keys(tabs).map((tab) => (
                  <button
                      key={tab}
                      onClick={() => setActiveTab(tab)}
                      style={{
                          padding: '10px 20px',
                          cursor: 'pointer',
                          backgroundColor: activeTab === tab ? '#4FD975' : '#ccc',
                          border: 'none',
                          outline: 'none',
                      }}
                  >
                      {tabs[tab].name}
                  </button>
              ))}
          </div>
          <div style={{ backgroundColor: '#4FD975', padding: 10, width: 'calc(100% - 20px)', left: 10, borderRadius: 7, height: '55px', overflowY: 'scroll', marginTop: 15, marginLeft: 10, marginBottom: 10 }}>
          {tabs[activeTab].description}
          </div>
          {tabs[activeTab].component}

      </div>
  );
}
function FileUploader() {
  const [fileInfo, setFileInfo] = useState("");

  const uploadImageFile = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64Data = reader.result.split(',')[1]; // Removes the 'data:image/*;base64,' part

        const bodyData = JSON.stringify({
          imageData: base64Data,
          mimeType: file.type
        });

        fetch('https://us-central1-flowroom-fd862.cloudfunctions.net/uploadImageHTTP', {
          method: 'POST',
          body: bodyData,
          headers: {
            'Content-Type': 'application/json'
          },
        })
        .then(response => response.json())
        .then(data => {
          if (data.imageUrl) {
            resolve(data.imageUrl);
          } else {
            reject('No image URL returned');
          }
        })
        .catch(error => {
          reject(error);
        });
      };

      reader.onerror = error => reject(error);

      reader.readAsDataURL(file);
    });
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    try {
      const imageUrl = await uploadImageFile(file);
      console.log(imageUrl);
      setFileInfo(`Uploaded successfully. Image URL: ${imageUrl}`);
    } catch (error) {
      console.error('Error uploading file:', error);
      setFileInfo(`Failed to upload file: ${error}`);
    }
  };

  return (
    <div>
      <input type="file" onChange={handleFileChange} accept="application/pdf, text/plain, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/jpeg, image/png, image/gif" />
    </div>
  );
}

let messages = [];
const AITrainer = (props) => {
  const [label, setLabel] = useState("");
  const WidgetStore = useContext(WidgetStoreContext);
  const FlowStore = useContext(FlowStoreContext);
  const [showDeleteWidget, setShowDeleteWidget] = useState(false);
  const [showUnlockWidget, setShowUnlockWidget] = useState(false);
  const [showLockWidget, setShowLockWidget] = useState(false);
  const [lock, setLock] = useState(false);
  const [chat, setChat] = useState([]);

  const [listData, setListData] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const [selectedName, setSelectedName] = useState(
    listData.length > 0 ? listData[0].name : ""
  );
  const [message, setMessage] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const messagesEndRef = React.useRef(null);
  const messageContainerRef = React.useRef(null);
    const [activeComponent, setActiveComponent] = useState(null);


    const renderComponent = () => {
        switch (activeComponent) {
            case 'link':
                return <LinkComponent />;
            case 'text':
                return <TextComponent />;
            case 'audio':
                return <AudioComponent />;
            case 'generateImage':
                return <GenerateImageComponent />;
            case 'image':
                return <ImageComponent />;
            case 'webSearch':
                return <WebSearchComponent />;
            case 'pdfInfo':
                return <PdfInfoComponent />;
            default:
                return <div>Click an icon to start!</div>;
        }
    };
  const scrollToBottom = () => {
    if (messageContainerRef.current) {
      setTimeout(() => {
        messageContainerRef.current.scrollTop =
          messageContainerRef.current.scrollHeight;
      }, 50);
    }
  };

  const scrollToTopOfLastMessage = () => {
    if (messageContainerRef.current && messagesEndRef.current) {
      setTimeout(() => {
        const buffer = 50; // Increase this value as needed
        const messageTop = messagesEndRef.current.offsetTop - buffer;
        messageContainerRef.current.scrollTop = messageTop;
      }, 50);
    }
  };

  useEffect(() => {
 
    // This function should be globally accessible by the JavaScript library
    window.appendChatMessages = appendChatMessages;
    setTimeout(()=>{
      scrollToTopOfLastMessage()
    }, 1000)
}, [message]);


const appendChatMessages = (newMessages) => {

    console.log('Received messages:', newMessages);
    messages = [];
    messages.push(...newMessages);
    setMessage([...newMessages]);
  

};

  return (
    <div
      style={{
        height: "320px",
        width: "100%",
        display:"block"
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          // marginBottom: 10,
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid #323232",
            paddingLeft: 7,
          }}
        >
          <p
            id={`label_${props.actualInstance}`}
            style={{
              fontFamily: "quicksand",
              fontSize: 16,
              color: "white",
              margin: 7,
            }}
          >
            {props.widgetLabel == '' || props.widgetLabel == undefined ? 'Chatbot UI Widget': props.widgetLabel}
          </p>
        </div>
      </div>
      {props.showInfo !== true ? (
        <div style={{ maxWidth: 383, width: "100vw", height:'100%', minHeight:500 }}>
          <div style={{ height:'calc(100vh - 500px)'  }}>
            <ul
              style={{
                height: 184,
                width: "100%",
                overflowY: "scroll",
                paddingLeft: 20,
                paddingTop: 3,
                paddingRight: 12,
                paddingBottom: 20,
              }}
              ref={messageContainerRef}
            >
              {messages.map((message, index) => (
                <li
                  key={index}
                  style={{
                    listStyle: "none",
                    display: "flex",
                    width: "100%",
                    marginTop: 10,
                    marginBottom: 10,
                    justifyContent:
                      message.role === "user" ? "flex-end" : "flex-start",
                  }}
                  ref={index === messages.length - 1 ? messagesEndRef : null}
                >
                  {message.role === "assistant" && (
                    <div
                      style={{
                        backgroundColor: "red",
                        height: 30,
                        width: 30,
                        borderRadius: "50%",
                        marginRight: 14,
                        flexShrink: 0, // Prevent shrinking
                      }}
                    ></div>
                  )}
                  <div
                    style={{
                      backgroundColor: "#3A4F40",
                      padding: 10,
                      color: "white",
                      fontFamily: "quicksand",
                      borderTopRightRadius: message.role === "user" ? 0 : 7,
                      borderBottomRightRadius: 7,
                      borderTopLeftRadius: message.role === "user" ? 7 : 0,
                      borderBottomLeftRadius: 7,
                      display: message.role !== "system" ? "block" : "none"
                    }}
                  >
                    {message.role !== "system" ? message.content : ""}
                  </div>
                  {message.role === "user" && (
                    <div
                      style={{
                        backgroundColor: "red",
                        height: 30,
                        width: 30,
                        borderRadius: "50%",
                        marginLeft: 14,
                        flexShrink: 0, // Prevent shrinking
                      }}
                    ></div>
                  )}
                </li>
              ))}
              <div ref={messagesEndRef} />
            </ul>
          </div>
          {/* {listData.length > 0 && (
            <select
              value={selectedIndex}
              onChange={(e) => setSelectedIndex(e.target.value)}
            >
              {listData.map((item, index) => (
                <option key={index} value={index}>
                  {item.name}
                </option>
              ))}
            </select>
          )} */}
         
          {props.trainMode == true ? (<TabMenu/>) : ( <div
            style={{
              display: "flex",
              margin: "auto",
              width:'100%',
              position: 'absolute',
              bottom: 28,
              left: 0,
              justifyContent:'center',
              alignItems:'center'
            }}
          >
            <input
              type="text"
              value={inputMessage}
              onChange={(e) => setInputMessage(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') { // Check if the pressed key is 'Enter'
                  let iframe = document.getElementById('undefined_output_frame'); // Make sure the ID matches your iframe's ID
                  if (iframe && iframe.contentWindow) {
                    iframe.contentWindow[props.functionName](inputMessage); // Call the function with the current input message
                    setInputMessage(""); // Clear the input message
                  }
                }

              }}
              placeholder="Response..."
              style={{
                backgroundColor: "#373737",
                height: 35,
                paddingLeft: 12,
                border: "none",
                borderTopLeftRadius: 7,
                borderBottomLeftRadius: 7,
                outline: "none",
                width: "calc(100% - 145px)",
                fontSize: 11,
                color: "white",
                fontFamily: "quicksand",
              }}
            />
            {/* <FileUploader/> */}
             
              <img src="../microphone.svg" style={{    height: 20,
    width: 20,
    position: 'absolute',
    marginTop: 0, right:100, cursor:'pointer'}}/>
            <button
              onClick={()=>{
                let iframe = document.getElementById('undefined_output_frame');
                iframe.contentWindow[props.functionName](inputMessage);
                setInputMessage("");
              }}
              style={{
                backgroundColor: "#4FD975",
                width: 35,
                height: 35,
                border: "none",
                borderRadius: 7,
              }}
            >
              <img src="../images/chat-arrow.svg" style={{ height: 15, width: 25, position: 'relative', marginTop: 5}}/>
            </button>
          </div>)}
                   
        </div>
      ) : (
        ""
      )}
      <p
        style={{
          color: "white",
          fontFamily: "quicksand",
          fontSize: 14,
          marginTop: 12,
        }}
      >
        {props.info}
      </p>


    </div>
  );
};

export default React.memo(AITrainer);
